"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyListings = void 0;
const propertyListingsGetAgentListingsPropertyListingsAgentListingsGet_js_1 = require("../funcs/propertyListingsGetAgentListingsPropertyListingsAgentListingsGet.js");
const propertyListingsGetPropertyListingsPropertyListingsGet_js_1 = require("../funcs/propertyListingsGetPropertyListingsPropertyListingsGet.js");
const propertyListingsUnmatchPropertyListingPropertyListingsUnmatchPropertyListingDelete_js_1 = require("../funcs/propertyListingsUnmatchPropertyListingPropertyListingsUnmatchPropertyListingDelete.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class PropertyListings extends sdks_js_1.ClientSDK {
    /**
     * Get Agent Listings
     *
     * @remarks
     * Get listing details using a Rightmove agent id.
     *
     * ## Multiple valued query parameters
     *
     * <details>
     * <summary>Click to view information on using query parameters that take multiple values</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
     *
     * </details>
     *
     * ## Pagination
     *
     * <details>
     * <summary>Click to view information on using pagination for this endpoint</summary>
     *
     *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
     * </details>
     */
    async getAgentListingsPropertyListingsAgentListingsGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, propertyListingsGetAgentListingsPropertyListingsAgentListingsGet_js_1.propertyListingsGetAgentListingsPropertyListingsAgentListingsGet)(this, security, request, options));
    }
    /**
     * Get Property Listings
     *
     * @remarks
     * Get listing details using a Rightmove listing id.
     *
     * - A lat/lon point can be provided instead of a listing id. If this is present, for each listing the distance from the point will be calculated and the results will be sorted in ascending order from this point.
     *
     * ## Multiple valued query parameters
     *
     * <details>
     * <summary>Click to view information on using query parameters that take multiple values</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
     *
     * </details>
     */
    async getPropertyListingsPropertyListingsGet(security, listingId, point, options) {
        return (0, fp_js_1.unwrapAsync)((0, propertyListingsGetPropertyListingsPropertyListingsGet_js_1.propertyListingsGetPropertyListingsPropertyListingsGet)(this, security, listingId, point, options));
    }
    /**
     * Unmatch Property Listing
     *
     * @remarks
     * Unmatch an incorrectly matched property listing.
     *
     * - This endpoint can be used to unmatch a `listing_id` from a `street_group_property_id` when the matched `street_group_property_id` is incorrect.
     * - The backend for Street Group Property Data API will be updated in realtime to remove the match and will take effect immediately.
     * - Both the `listing_id` and `street_group_property_id` must be provided.
     * - **Ensure that the `listing_id` and `street_group_property_id` are correct before using this endpoint**. There is no way to undo this change.
     * - On a successful unmatch the endpoint will return HTTP 204 without a response body.
     */
    async unmatchPropertyListingPropertyListingsUnmatchPropertyListingDelete(security, listingId, streetGroupPropertyId, options) {
        return (0, fp_js_1.unwrapAsync)((0, propertyListingsUnmatchPropertyListingPropertyListingsUnmatchPropertyListingDelete_js_1.propertyListingsUnmatchPropertyListingPropertyListingsUnmatchPropertyListingDelete)(this, security, listingId, streetGroupPropertyId, options));
    }
}
exports.PropertyListings = PropertyListings;
//# sourceMappingURL=propertylistings.js.map